/**
 * The delegation scopes a client company grants an accounting firm, one per
 * firm link (`FirmTenantLink.roleCode`).
 *
 * Each scope maps to a system role of the client file; the role's
 * permissions live in the API's role registry (`BASE_SYSTEM_ROLES`), which
 * the firm session resolves on every request.
 */
export const FIRM_DELEGATION_SCOPES = [
    "CONSULTATION",
    "TENUE",
    "TENUE_DECLARATIONS",
    "MANDAT_COMPLET",
];
/** The system role each scope applies in the client file. */
export const FIRM_DELEGATION_SCOPE_ROLES = {
    CONSULTATION: "DELEGATION_CONSULTATION",
    TENUE: "DELEGATION_TENUE",
    TENUE_DECLARATIONS: "DELEGATION_TENUE_DECLARATIONS",
    MANDAT_COMPLET: "ACCOUNTANT",
};
/** The scope a link gets when the client accepts without choosing one. */
export const DEFAULT_FIRM_DELEGATION_SCOPE = "TENUE_DECLARATIONS";
export const FIRM_DELEGATION_SCOPE_LABELS = {
    CONSULTATION: "Consultation",
    TENUE: "Tenue comptable",
    TENUE_DECLARATIONS: "Tenue et déclarations fiscales et sociales",
    MANDAT_COMPLET: "Mandat complet",
};
export const FIRM_DELEGATION_SCOPE_DESCRIPTIONS = {
    CONSULTATION: "Audit ou commissariat aux comptes : lecture seule des livres, des factures de vente et des déclarations",
    TENUE: "Saisie et validation des écritures, sans déclarations ni paie",
    TENUE_DECLARATIONS: "Tenue comptable, déclarations fiscales et sociales, liasse eSINTAX et visa DSF, sans paie",
    MANDAT_COMPLET: "Tenue comptable, déclarations, clôture des exercices et paie",
};
/**
 * Permissions no firm session holds, whatever the scope: invoice creation
 * and signing (the till included, every till act ends in a signed sale or
 * its closing), MCF actions, the Z closing, user and role administration.
 * The API removes them from the resolved permissions of every firm grant,
 * a role wildcard (`reports:*`) included.
 */
export const NEVER_DELEGABLE_PERMISSIONS = [
    "invoices:create",
    "invoices:update",
    "invoices:delete",
    "invoices:sign",
    "invoices:submit",
    "invoices:credit-note",
    "invoices:payment-cancel",
    "invoices:write",
    "pos:access",
    "pos:session",
    "pos:transaction",
    "pos:payment",
    "pos:suspend",
    "pos:cancel",
    "pos:price-override",
    "hospitalite:sejours",
    "mcf:arbitrer-signature",
    "mcf:connect",
    "mcf:declarer-panne",
    "mcf:gerer-appareils",
    "mcf-agent:enroll",
    "reports:close",
    "users:create",
    "users:read",
    "users:update",
    "users:delete",
    "users:roles",
    "roles:create",
    "roles:read",
    "roles:update",
    "roles:delete",
];
export function isFirmDelegationScope(value) {
    return (typeof value === "string" &&
        FIRM_DELEGATION_SCOPES.includes(value));
}
/** The scope a role code stands for, or null when it is no delegation role. */
export function firmDelegationScopeForRole(roleCode) {
    for (const scope of FIRM_DELEGATION_SCOPES) {
        if (FIRM_DELEGATION_SCOPE_ROLES[scope] === roleCode)
            return scope;
    }
    return null;
}
//# sourceMappingURL=firm-delegation.js.map